import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ReportPaymentService {
  private apiUrl = environment.apiUrl + '/report_payments/';  // Usa la variable global
  private http = inject(HttpClient); // Inyección sin constructor

  private  currentPaymentAttachmentId = new BehaviorSubject<any>(null);
  currentPaymentAttachmentId$ = this.currentPaymentAttachmentId.asObservable();
  
  setCurrentPaymentAttachmentId(paymentAttachmentId: any) {
    this.currentPaymentAttachmentId.next(paymentAttachmentId);
  }

  getAttachmentById(id: String): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}getAttachmentById/${id}`);
   }

  get(periodId?: string): Observable<any> {
    let httpParams = new HttpParams();
    if (periodId) httpParams = httpParams.set('periodId', periodId);
    return this.http.get(`${this.apiUrl}get`, { params: httpParams });
  }

  save(userData: any): Observable<any> {
    return this.http.post(this.apiUrl + 'save/', userData);
  }
}